import React from 'react'

import PrivateSaleRegistrationForm from '@/Form/PrivateSaleRegistrationForm'

import WaitOpenPrivateSale from '@/WaitOpenPrivateSale'

export default function PrivateSaleRegistration ({ onRegister, data })
{
	if (!data) return null;

	return (
		<WaitOpenPrivateSale data={ data }>
			<div className="c-VP-registration">
				<PrivateSaleRegistrationForm data={ data } onRegister={ onRegister } />
			</div>
		</WaitOpenPrivateSale>
	);
}
